import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import TranslationLanguageForm from "./TranslationLanguageForm";
import TranslationLanguageList from "./TranslationLanguageList";

export default function TranslationLanguage({ match }) {
    return (
        <RouteMenu match={match} indexComponent={TranslationLanguageList}>
            <Route path={path.join(match.url, 'new')} component={TranslationLanguageForm} />
            <Route path={path.join(match.url, 'edit/:id')} component={TranslationLanguageForm} />
        </RouteMenu>
    );
}